import React from 'react';

const Research = () => {
  return (
    <div>
      <h2>Research Page</h2>
      <p>Welcome to the Research page!</p>
    </div>
  );
};

export default Research;